import { type ReactNode } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogFooter,
} from '@/components/ui/dialog';

import { Button } from '../ui/button';

interface ConfirmationPopupProps {
  isOpen: boolean;
  title: string;
  children: ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmColor?: 'primary' | 'secondary' | 'error';
  isLoading?: boolean;
  statusMessage?: string;
  statusType?: 'success' | 'error' | 'info' | 'warning';
}

const ConfirmationPopup = ({
  isOpen,
  title,
  children,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  isLoading = false,
  statusMessage,
  statusType = 'error',
}: ConfirmationPopupProps) => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onCancel();
        }
      }}
    >
      <DialogContent>
        <DialogTitle>{title}</DialogTitle>
        {children}
        {statusMessage && (
          <div className={`status ${statusType}`}>{statusMessage}</div> //TODO: add a status message component
        )}
        <DialogFooter>
          <Button type="button" onClick={onCancel} variant="ghost">
            {cancelText}
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            variant="destructive"
            tabIndex={-1}
            disabled={isLoading || !!statusMessage}
          >
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationPopup;
